import { useState, useEffect } from 'react'
import { Box, Input } from 'theme-ui'
import useDebounce from '../../../hooks/useDebounce'

function FilterText({ value, icon, onChange }) {
    const [fieldValue, setFieldValue] = useState(value)
    const debouncedFieldName = useDebounce(fieldValue, 500)

    useEffect(() => {
        onChange(debouncedFieldName)
    }, [debouncedFieldName])

    return (
        <>
            <Box
                sx={{
                    height: 52,
                    display: 'flex',
                    alignItems: 'center',
                    borderBottomColor: 'border',
                    borderBottomWidth: 1,
                    borderBottomStyle: 'solid',
                    cursor: 'pointer',
                    position: 'relative',
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        top: 0,
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    {icon}
                </Box>
                <Input
                    placeholder="Search by name"
                    sx={{ fontSize: 2, borderWidth: 0, pl: 5 }}
                    value={fieldValue || ''}
                    onChange={(e) => setFieldValue(e.target.value)}
                />
            </Box>
        </>
    )
}

export default FilterText
